//The schema describes how to select data/files on the site server/database
const schema = {
    //identify the update object by a uuid.v4
    id: "",
    //The type of data this object is selecting
    type: {},
    //The query to select the data
    query: {},
    //A details string to describe the update for the user
    details: "",
    //The number of items that were selected by the query
    itemCount: 0,
    //the item identifiers that should be included in the update ( the rest will be excluded)
    include: [],
    //the item identifiers that should be excluded from the update ( the rest will be included)
    exclude: [],
}

//This schema is used to create new UpdateConfiguration objects
export default schema